export const QUERY_PARAM = 'channel'
